import Vue from 'vue'
import Router from 'vue-router'
import loginPassword from '@/components/loginPassword'
import loginVerifyCode from '@/components/loginVerifyCode'
import resetPassword from '@/components/resetPassword'
import shareRegister from '@/components/shareRegister'
import emailFindPsw from '@/components/emailFindPsw'
import index from '@/components/index'
import home from '@/components/home'
import error from '@/components/error'
import download from '@/components/download'
import payList from '@/components/payList'
import toPay from '@/components/toPay'

import email from '@/components/email'
import addChild from '@/components/addChild'
import add from '@/components/add'

import payHistory from '@/components/payHistory'
import paySuccess from '@/components/paySuccess'
import curriculum from '@/components/curriculum'
import allChild from '@/components/allChild'
import recharge from '@/components/recharge'

import coursesSchedule from '@/components/course'
import coursesScheduleMobile from '@/components/courseMobile'

import AttendClassNow from '@/components/children/AttendClassNow'
import ClassEnrolled from '@/components/children/ClassEnrolled'
import ViewCompletedLessons from '@/components/children/ViewCompletedLessons'
import ScheduleaClass from '@/components/children/ScheduleaClass'
import PurchaseLessonPlan from '@/components/children/PurchaseLessonPlan'

import information from '@/components/children/information'
import addChildren from '@/components/children/addChildren'
import Transaction from '@/components/children/Transaction'
import MonthlyPassUser from '@/components/children/MonthlyPassUser'
import ChangePlan from '@/components/children/ChangePlan'
import MonthyuStatement from '@/components/children/MonthyuStatement'
import CompletePayment from '@/components/children/CompletePayment'
import  Salecard from '@/components/salecard'

import newUser from '@/components/newUser'
import nuinfo from '@/components/nuinfo'
import sinadd from '@/components/sinadd'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'loginVerifyCode',
      component: loginVerifyCode
    },{
      path: '/salecard',
      name: 'salecard',
      component: Salecard
    },
    {
      path: '/newUser',
      name: "newUser",
      component: newUser
  },
  {
      path: '/nuinfo',
      name: "nuinfo",
      component: nuinfo
  },
  {
    path: '/sinadd',
    name: "sinadd",
    component: sinadd
},
    {
      path: '/email',
      name: 'email',
      component: email
    },
    {
      path: '/addChild',
      name: 'addChild',
      component: addChild
    },
    {
      path: '/add',
      name: 'add',
      component: add
    },
    {
      path: '/curriculum',
      name: 'curriculum',
      component: curriculum
    },
    {
      path: '/loginPassword',
      name: 'loginPassword',
      component: loginPassword
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: resetPassword
    },
    // {
    //   path: '/index',
    //   name: 'index',
    //   component: index
    // },
    {
      path: '/allChild',
      name: 'allChild',
      component: allChild
    },
    {
      path: '/payHistory',
      name: 'payHistory',
      component: payHistory
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component: paySuccess
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: recharge
    },
    {
      path: '/shareRegister',
      name: 'shareRegister',
      component: shareRegister
    },
    {
      path: '/download',
      name: 'download',
      component: download
    },
    {
      path: '/emailFindPsw',
      name: 'emailFindPsw',
      component: emailFindPsw
    },
    {
      path: '/payList',
      name: 'payList',
      component: payList
    },
    {
      path: '/toPay',
      name: 'toPay',
      component: toPay
    },
    {
      path: '/schedules_pc',
      name: 'coursesSchedule',
      component: coursesSchedule
    },
    {
      path: '/schedules_app',
      name: 'coursesScheduleMobile',
      component: coursesScheduleMobile
    },
    {
      path: '*',
      component: error
    },

    {
      path: '/home',
      name: 'home',
      component: home,
      children:[
        {
          path:'/home/children/AttendClassNow',
          component:AttendClassNow
        },
        {
          path:'/home/children/ClassEnrolled',
          component:ClassEnrolled
        },
        {
          path:'/home/children/ViewCompletedLessons',
          component:ViewCompletedLessons
        },
        {
          path:'/home/children/ScheduleaClass',
          component:ScheduleaClass,
        },
        {
          path:'/home/children/PurchaseLessonPlan',
          component:PurchaseLessonPlan   
        },
        {
          path:'/home/children/information',
          component:information
        },
        {
          path:'/home/children/addChildren',
          component:addChildren
        },
        {
          path:'/home/children/Transaction',
          component:Transaction
        },
        {
          path:'/home/children/MonthlyPassUser',
          component:MonthlyPassUser
        },
        {
          path:'/home/children/ChangePlan',
          component:ChangePlan
        },
        {
          path:'/home/children/MonthyuStatement',
          component:MonthyuStatement
        },
        {
          path:'/home/children/CompletePayment',
          component:CompletePayment
        },
      ]
    },
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js